// extracted by mini-css-extract-plugin
export default {"hover_menu":"download_menu_hover_menu__jPKYR","table_action_icon":"download_menu_table_action_icon__RyTAU","menu_button":"download_menu_menu_button__c3-GF"};